import { Suspense } from "react";
import Loader from "../components/Loader";

export const withSuspense = (Component: $TSFixMe, componentName: $TSFixMe) =>
  function LazyComponent(props: $TSFixMe) {
    // eslint-disable-next-line
    const spinner = props.loader || <Loader loading />;
    (LazyComponent as $TSFixMe).displayName = componentName;

    return (
      <Suspense fallback={spinner}>
        <Component {...props} />
      </Suspense>
    );
  };

export default withSuspense;
